import styled from 'styled-components';
import { Emoji } from '@frameio/shared/emoji';
import { imageLoader } from '@frameio/utils';
import type {
  AvatarSizes,
  ThemeColorsBackground,
  ThemeColorsMeta,
} from '@frameio/vapor';
import { Avatar, theme, Tooltip } from '@frameio/vapor';

type Props = {
  background: ThemeColorsBackground | ThemeColorsMeta;
  emoji?: string;
  size?: AvatarSizes;
  src?: string;
  title: string;
};

export const InviteButtonAvatar = ({
  background,
  emoji,
  size,
  src,
  title,
}: Props) => {
  return (
    <AvatarWrapper>
      <Tooltip placement="top" title={title}>
        <Avatar
          alt={emoji || title}
          background={background}
          role="img"
          shape="circle"
          size={size}
          src={
            src &&
            (src.includes('picture2')
              ? imageLoader({
                  src,
                  width: 64,
                })
              : src)
          }
        >
          {emoji && (
            <span
              aria-label={emoji}
              role="img"
              style={{
                fontSize: theme.fontSizes[100],
              }}
            >
              <Emoji emoji={emoji} size={16} />
            </span>
          )}
        </Avatar>
      </Tooltip>
    </AvatarWrapper>
  );
};

const AvatarWrapper = styled.span`
  @container finder-menu-bar (max-width: 400px) {
    display: none;
  }

  @container finder-menu-bar (min-width: 400px) {
    display: block;
  }
`;
